const Home = () => {
  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold">Dashboard Content</h2>
      {/* Add dashboard widgets here if needed */}
    </div>
  );
};

export default Home;
